// Opens mega menu panels on hover instead of requiring a click, for desktop
// pointer devices only (hover-capable + precise pointer, i.e. a real mouse).
// Touch devices and mobile are untouched by this - mobile doesn't render
// this component at all, and any touch-with-mouse hybrid keeps native
// click/keyboard behavior working exactly as before, this only adds hover
// on top of it.
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function setup() {
    document.querySelectorAll('header-menu').forEach(function (menu) {
      var details = menu.querySelector('details');
      if (!details || menu.dataset.hoverBound) return;
      menu.dataset.hoverBound = 'true';

      var closeTimer;

      menu.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
        }
      });

      menu.addEventListener('mouseleave', function () {
        // small delay so moving the mouse from the menu label down into the
        // panel doesn't snap it shut before the cursor gets there
        closeTimer = setTimeout(function () {
          details.removeAttribute('open');
        }, 150);
      });
    });
  }

  if (document.readyState !== 'loading') {
    setup();
  } else {
    document.addEventListener('DOMContentLoaded', setup);
  }
  document.addEventListener('shopify:section:load', setup);
})();